import { useTranslation } from "react-i18next";
import { PermissionSource } from "types/Permissions";
import { permissionNameKey } from "./permission-labels";

type PermissionChipsProps = {
  /** `sources` is left out where the reason does not matter (a position's own list). */
  permissions: { key: string; sources?: PermissionSource[] }[];
};

/** Read-only list of rights by name, each with why the person holds it. */
export default function PermissionChips({ permissions }: PermissionChipsProps) {
  const { t } = useTranslation();

  const reasonOf = (source: PermissionSource) =>
    source.type === "manual"
      ? t("perm_source_manual")
      : t("perm_source_position", { position: source.positionName });

  return (
    <ul className="flex flex-wrap gap-1.5">
      {permissions.map(({ key, sources }) => (
        <li
          key={key}
          className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800"
        >
          {t(permissionNameKey(key), { defaultValue: key })}
          {sources && sources.length > 0 && (
            <span className="font-normal text-gray-500">
              {" "}
              ({sources.map(reasonOf).join(", ")})
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
